<template>
  <div class="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <!-- Main Headline -->
      <div class="mb-16">
        <h1 class="text-5xl md:text-7xl font-bold text-gray-900 mb-6">
          Biljetter
          <span class="text-indigo-600">.org</span>
        </h1>
        <p class="text-xl md:text-2xl text-gray-600 max-w-2xl mx-auto">
          Upptäck och boka spännande evenemang i din stad
        </p>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-col sm:flex-row gap-6 justify-center items-center">
        <router-link 
          :to="{ path: '/login', query: { role: 'buyer' } }"
          class="w-full sm:w-auto bg-indigo-600 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:bg-indigo-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
        >
          Biljettköpare
        </router-link>

        <router-link 
          :to="{ path: '/login', query: { role: 'organizer' } }"
          class="w-full sm:w-auto bg-white text-indigo-600 px-8 py-4 rounded-xl text-lg font-semibold border-2 border-indigo-600 hover:bg-indigo-50 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
        >
          Eventorganisatör
        </router-link>
      </div>

      <!-- Additional Info -->
      <div class="mt-16 text-gray-500">
        <p class="text-sm">Välj din väg: Biljettköpare eller Eventorganisatör</p>
      </div>
    </div>
  </div>
</template>

<script setup>
// No script needed for this simple landing page
</script>

<style scoped>
/* No additional styles needed */
</style>
